enum WorkspaceProjectLandOwnershipType {
  'Carbon rights holder owned' = 'Carbon rights holder owned',
  'Community individual owned' = 'Community individual owned',
  'Community village owned' = 'Community village owned',
  'Few large land owners' = 'Few large land owners',
  'Government owned' = 'Government owned',
}

export default WorkspaceProjectLandOwnershipType
